export default __webpack_public_path__ + "static/1-a4c823f79c035b57d2510dd4e41faf9c.jpeg";